import { render, staticRenderFns } from "./SearchTable.vue?vue&type=template&id=4a39f9b0"
import script from "./SearchTable.vue?vue&type=script&lang=js"
export * from "./SearchTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a39f9b0')) {
      api.createRecord('4a39f9b0', component.options)
    } else {
      api.reload('4a39f9b0', component.options)
    }
    module.hot.accept("./SearchTable.vue?vue&type=template&id=4a39f9b0", function () {
      api.rerender('4a39f9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/LogisticsTable/SearchTable.vue"
export default component.exports